import { OrderService } from './model/squareup/buyerportal/orders/service';
import rpc from './rpc';

const ordersClient = OrderService.create(rpc());

export default ordersClient;
